import { Component, OnDestroy, effect, input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { IUserAuthObj, IUserAuthRes, IViewManageUserAuthsState } from '../../store/viewManageUserAuths/state';
import { Lux } from '@roosevelt/common-ui-lib/core';
import { IPTAppGeneralState } from '../../store/appGeneral/state';
import { getUserAuths } from '../../store/viewManageUserAuths/selector';
@Component({
    selector: 'pt-app-view-user-auths',
    templateUrl: './view-user-auths.component.html',
    styleUrl: '../view-manage-user-auths.component.scss',
    standalone: false
})
export class ViewUserAuthsComponent implements OnDestroy {
  luxID = 'PT-ViewUserAuthsComponent'+this.constructor.name;
  // Signal migration: convert auth stream to a signal in injection context.
  userAuthsData = toSignal(this.lux.get(getUserAuths, this.luxID), {
    initialValue: { userAuthorizations: [], pagination: { totalRecords: 0, offset: 0, limit: 0 } } as IUserAuthRes
  });
  userAndAdminAuths = input<IUserAuthObj[]>([]);
  private readonly tableHeadersSig = signal<string[]>(['tin', 'agencyName', 'npn' ,'agentName' ]);
  get userAndAdminAuthsValue(): IUserAuthObj[] { return this.userAndAdminAuths(); }

  get tableHeaders(): string[] {
    return this.tableHeadersSig();
  }

  fullIndicatorsArray: string[] = ['groupCommissionStatementsInd','individualCommissionStatementsInd','groupBookOfBusinessInd','individualBookOfBusinessInd','documentsInd'];

  constructor(
    private lux: Lux<{
      appGeneralState: IPTAppGeneralState,
      viewManageUserAuthsState: IViewManageUserAuthsState
    }>
  ){
    // Signal migration: effect replaces auth subscription and table/header propagation.
    effect(() => {
      const auths = this.userAuthsData();
      let indicatorsArray: string[] = this.populateIndsArray(auths);
      this.updateTableHeaders(indicatorsArray);
    });
  }

  private populateIndsArray(auths: IUserAuthRes) {
    let indicatorsArray: string[] = [];
    let indArrayForEmptySpaces = this.fullIndicatorsArray;
    let items = auths.userAuthorizations;
    for (let i = 0; i < items.length; i++) {
      Object.entries(items[i].invokingUserAuthorizations).forEach(([key, value]) => {
        if (value && !indicatorsArray.includes(key)) {
          indicatorsArray.push(key);
          let indexToRemove = indArrayForEmptySpaces.indexOf(key);
          if (indexToRemove > -1) {
            indArrayForEmptySpaces.splice(indexToRemove, 1);
          }
        }
      });
    }
    indicatorsArray = indicatorsArray.sort((x,y) => x < y ? 1 : -1);
    if (indArrayForEmptySpaces && indArrayForEmptySpaces.length > 0) {
      for (let j = 0; j < indArrayForEmptySpaces.length; j++) {
        indicatorsArray.push('empty');
      }
    }
    return indicatorsArray;
  }

  updateTableHeaders(indicatorsArray: string[]) {
    if (indicatorsArray && indicatorsArray.length > 0) {
      this.tableHeadersSig.set(['tin', 'agencyName', 'npn', 'agentName', ...indicatorsArray]);
      return;
    }
    this.tableHeadersSig.set(['tin', 'agencyName', 'npn' ,'agentName' ]);
  }

  ngOnDestroy(): void {
    this.lux.destroy(this.luxID);
  }
}
